import { useContext } from 'react'
import RoleContext from '../auth/RoleContext'
import Body from "./Body"
import Sidebar from "./Sidebar"
import SidebarMenu from "./SidebarMenu.js"
import { useLocation } from 'react-router-dom'
import SidebarCommunityMenu from './SidebarCommunityMenu.js'
import FeatureFlagsContext from '../config/FeatureFlagsContext'

const COMMUNITY_MENU_PREFIXES = ['/qse-community-hub','/quality-hub','/safety-community-hub','/sustainability-hub']

const matchesPrefixes = (pathname, prefixes) =>
  prefixes.some(prefix => pathname.startsWith(prefix));

export default function AuthenicatedLayout(props = {}) {
  const roleContext = useContext(RoleContext)
  const location = useLocation()
  // const history = useHistory()
  const ff = useContext(FeatureFlagsContext)

  const isCommunityContext = matchesPrefixes(location.pathname, COMMUNITY_MENU_PREFIXES)

  return ff.featureFlags.communityHub && isCommunityContext ? (
    <>
      { roleContext.hasAnyRole() && <>
        <Sidebar
            menu={SidebarCommunityMenu}
          />
        <Body {...props} />
      </>}
    </>
  ) : (
    <>
      { roleContext.hasAnyRole() && <>
        <Sidebar
            menu={SidebarMenu}
          />
        <Body {...props} />
      </>}
    </>
  )
}